import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CheckCircle, AlertTriangle } from 'lucide-react';
export function TrustSection() {
  return <section className="py-10 px-4 bg-[#fdf8f3] relative overflow-hidden border-y border-gray-200" data-id="element-346" data-mp="rug6ojjapyza">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-[#d97706]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-347" data-mp="11n5gzb3416t1" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-348" data-mp="4183xt7i1toh">
        <div className="text-center mb-12" data-id="element-349" data-mp="8yzxssrpfpvb">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-green-500/10 border border-green-500/20 text-green-400 text-sm font-bold mb-6" data-id="element-350" data-mp="8zrpvtm3f5gu">
            <ShieldCheck className="w-4 h-4" data-id="element-351" data-mp="2pwd8kqd3vz7g" />
            COMPRA 100% SEGURA Y GARANTIZADA
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-5xl font-black text-gray-900 mb-6 leading-tight uppercase" data-id="element-352" data-mp="2kxtqj11mv7kd">
            TU COMPRA ESTÁ PROTEGIDA <br data-id="element-353" data-mp="1x764zcysojfc" />
            <span className="text-green-600" data-id="element-354" data-mp="1x6o6e9ontt49">
              CONFIANZA TOTAL Y GARANTIZADA.
            </span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-355" data-mp="1t75pdozym26p">
            Sabemos que internet está lleno de promesas vacías. Por eso,
            queremos ser 100% transparentes con vos antes de que tomes cualquier
            decisión.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-356" data-mp="14ky7vc9cydaw">
          {/* Trust Point 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm" data-id="element-357" data-mp="1sb2bvkqgkf2f">
            <div className="w-12 h-12 bg-green-500/10 rounded-xl flex items-center justify-center mb-4" data-id="element-358" data-mp="2b8mtq7ut2ddj">
              <Lock className="w-6 h-6 text-green-500" data-id="element-359" data-mp="2g04p8ge27lr4" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-360" data-mp="4kmekc2odgrl">
              Pago Protegido
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-361" data-mp="3vrp6x6u91t3e">
              Tu pago se procesa a través de plataformas líderes. Nosotros nunca
              vemos los datos de tu tarjeta. Tu inversión está protegida de
              principio a fin.
            </p>
          </motion.div>

          {/* Trust Point 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm" data-id="element-362" data-mp="3hs7bi8mg7hl2">
            <div className="w-12 h-12 bg-blue-500/10 rounded-xl flex items-center justify-center mb-4" data-id="element-363" data-mp="161v8guxccwg9">
              <CheckCircle className="w-6 h-6 text-blue-500" data-id="element-364" data-mp="120jrtewg3lk7" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-365" data-mp="122mf3r67r0l8">
              Acceso Inmediato
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-366" data-mp="21c1qz12z2uj7">
              Nada de esperar días. Una vez confirmado el pago, recibís el
              acceso a todo el material automáticamente en tu email. Sin
              vueltas.
            </p>
          </motion.div>

          {/* Trust Point 3 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm" data-id="element-367" data-mp="2g9kdrxw3axo0">
            <div className="w-12 h-12 bg-yellow-500/10 rounded-xl flex items-center justify-center mb-4" data-id="element-368" data-mp="2z0v52g5q9cgf">
              <AlertTriangle className="w-6 h-6 text-yellow-500" data-id="element-369" data-mp="33zy7rty8j6l8" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-370" data-mp="sbtf8h0htvda">
              Garantía Real
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-371" data-mp="nbf4gr7ic7bk">
              Si el contenido no es lo que esperabas, tenés 7 días de garantía.
              Nuestra prioridad es que aprendas un oficio real y rentable con
              resultados garantizados.
            </p>
          </motion.div>

          {/* Trust Point 4 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm" data-id="element-372" data-mp="1b442j2inzkqa">
            <div className="w-12 h-12 bg-purple-500/10 rounded-xl flex items-center justify-center mb-4" data-id="element-373" data-mp="1p1spqh07f3yi">
              <ShieldCheck className="w-6 h-6 text-purple-500" data-id="element-374" data-mp="3j9wij52a6z1t" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-375" data-mp="3jc0khhgmdnzg">
              Soporte Humano
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-376" data-mp="39juw0hpktop0">
              Detrás de este curso hay personas reales. Si tenés algún problema
              con el acceso o el material, nuestro equipo te ayuda por Email.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="mt-12 p-6 bg-green-500/5 border border-green-500/20 rounded-2xl text-center" data-id="element-377" data-mp="30l9g6ubhonrx">
          <p className="text-green-400 font-medium italic" data-id="element-378" data-mp="ort0rvyrk0ld">
            "Mi reputación vale más que cualquier venta. Este curso es el
            resultado de años de trabajo y quiero que sea tu puerta de entrada a
            un negocio rentable."
          </p>
        </motion.div>
      </div>
    </section>;
}